import { HubConnectionBuilder, HubConnectionState, LogLevel, RetryContext } from '@microsoft/signalr';
import { UserStore } from '@/store/user-module';
import { StopwatchStore } from '@/store/stopwatch-store';
import { TimeEntryStore } from '@/store/time-entry-store';
import { AbsenceStore } from '@/store/absence-store';
import { ApprovalStore } from '@/store/approval-store';

const stHub = {
  install(Vue: any) {
    const options: any = {};
    const apiBasePath = process.env.VUE_APP_APIURL!.replace(/\/+$/, '');
    const connection = new HubConnectionBuilder()
      .withUrl(apiBasePath + '/sthub', options)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
          // let seconds = Math.floor(Math.random() * 30)
          // return seconds * 1000;
          return 10000;
        },
      })
      .configureLogging(LogLevel.Critical)
      .build();

    const stHub = new Vue();
    Vue.prototype.$stHub = stHub;

    connection.onreconnected(async () => {
      let milliSeconds = Math.floor(Math.random() * 20) * 1000;
      console.log(`Reconnected - retrying in ${milliSeconds}ms`);

      setTimeout(async () => {
        await UserStore.reloadStore();
        await StopwatchStore.loadStopwatch();
        await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);
      }, milliSeconds)

    });

    connection.on('updateSettings', async (id) => {
      await UserStore.reloadStore();
    });

    connection.on('timeEntriesChange', async (id) => {
      await StopwatchStore.loadStopwatch();
      await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);
    });

    connection.on('updateOpenAbsenceRequestCount', async (id) => {
      await AbsenceStore.getOpenAbsenceRequestCount();
    });

    connection.on('updateApprovalCount', async (id) => {
      await ApprovalStore.getOpenApprovalRequestCount();
    });

    connection.on('updateTimeEntryApprovals', async (id) => {
      await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);
      await ApprovalStore.getModel();
    });

    stHub.getIsDisconnected = function () {
      return connection.state == HubConnectionState.Disconnected;
    };

    stHub.getIsConnected = function () {
      return connection.state == HubConnectionState.Connected;
    };

    stHub.logon = async function () {
      await connection.invoke('LoggedOn');
    };

    stHub.logoff = async function () {
      await connection.invoke('LoggedOff');
    };

    stHub.start = async function () {
      await connection.start();
    };

    stHub.stop = async function () {
      try {
        await connection.stop();
      } catch (err) {
        setTimeout(() => stHub.stop(), 5000);
      }
    };
    //
    // connection.onclose(() => {
    //   stHub.start();
    // });
  },
};

export default stHub;
